const options = {
  5: "bg-amber-600/5",
  10: "bg-amber-600/10",
  25: "bg-amber-600/25",
  50: "bg-amber-600/50",
  75: "bg-amber-600/75",
  90: "bg-amber-600/90",
  100: "bg-amber-600",
};

const from = {
  5: "from-amber-600/5",
  10: "from-amber-600/10",
  25: "from-amber-600/25",
  50: "from-amber-600/50",
  75: "from-amber-600/75",
  90: "from-amber-600/90",
  100: "from-amber-600",
};

export default function getBackgroundAmber600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
